const capacityCalculatorData = {
  'Shampoo': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Shampoo we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Shampoo we recommend the 132 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Shampoo we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Shampoo we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Shampoo we recommend the 132 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Shampoo we recommend the 275 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Medium',
        text: 'For Shampoo we recommend the 132 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Large',
        text: 'For Shampoo we recommend the 275 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Shampoo we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
  'Conditioner': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Conditioner we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Conditioner we recommend the 132 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Conditioner we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Conditioner we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Conditioner we recommend the 132 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Conditioner we recommend the 275 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Medium',
        text: 'For Conditioner we recommend the 132 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Large',
        text: 'For Conditioner we recommend the 275 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Conditioner we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
  'Moisturizer': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Moisturizer we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Small',
        text: 'For Moisturizer we recommend the 56 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Moisturizer we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Moisturizer we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Moisturizer we recommend the 132 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Moisturizer we recommend the 132 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Medium',
        text: 'For Moisturizer we recommend the 132 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Large',
        text: 'For Moisturizer we recommend the 275 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Moisturizer we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
  'Cleanser': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Cleanser we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Small',
        text: 'For Cleanser we recommend the 56 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Cleanser we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Cleanser we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Small',
        text: 'For Cleanser we recommend the 56 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Cleanser we recommend the 132 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Medium',
        text: 'For Cleanser we recommend the 132 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Large',
        text: 'For Cleanser we recommend the 275 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Cleanser we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
  'Body Wash': {
    'Small': {
      'Single-day': {
        product: 'Medium',
        text: 'For Body Wash we recommend the 132 for light use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Body Wash we recommend the 132 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Body Wash we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Medium',
        text: 'For Body Wash we recommend the 132 for average use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Body Wash we recommend the 132 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Body Wash we recommend the 132 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Medium',
        text: 'For Body Wash we recommend the 132 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Body Wash we recommend the 132 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Body Wash we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
  'Lotion': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Lotion we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Small',
        text: 'For Lotion we recommend the 56 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Lotion we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Lotion we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Small',
        text: 'For Lotion we recommend the 56 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Lotion we recommend the 132 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Small',
        text: 'For Lotion we recommend the 56 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Lotion we recommend the 132 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Lotion we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
  'Serum': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Serum we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Small',
        text: 'For Serum we recommend the 56 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Serum we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Serum we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Small',
        text: 'For Serum we recommend the 56 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Serum we recommend the 132 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Small',
        text: 'For Serum we recommend the 56 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Small',
        text: 'For Serum we recommend the 56 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Serum we recommend the 132 for heavy use over 4-7 days.'
      }
    }
  },
  'Makeup remover': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Makeup Remover we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Makeup Remover we recommend the 132 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Makeup Remover we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Makeup Remover we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Makeup Remover we recommend the 132 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Makeup Remover we recommend the 132 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Small',
        text: 'For Makeup Remover we recommend the 56 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Makeup Remover we recommend the 132 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Makeup Remover we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
  'Toner': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Toner we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Toner we recommend the 132 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Toner we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Toner we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Toner we recommend the 132 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Toner we recommend the 132 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Small',
        text: 'For Serum we recommend the 56 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Serum we recommend the 132 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Serum we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
  'Hair serum': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Hair Serum we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Hair Serum we recommend the 132 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Hair Serum we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Hair Serum we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Hair Serum we recommend the 132 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Hair Serum we recommend the 132 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Small',
        text: 'For Hair Serum we recommend the 56 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Hair Serum we recommend the 132 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Hair Serum we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
  'Hair gel': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Hair Gel we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Hair Gel we recommend the 132 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Hair Gel we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Hair Gel we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Hair Gel we recommend the 132 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Hair Gel we recommend the 275 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Small',
        text: 'For Hair Gel we recommend the 56 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Hair Gel we recommend the 132 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Hair Gel we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
  'Leave-in Conditioner': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Leave-in Conditioner we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Leave-in Conditioner we recommend the 132 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Leave-in Conditioner we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Leave-in Conditioner we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Leave-in Conditioner we recommend the 132 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Leave-in Conditioner we recommend the 275 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Small',
        text: 'For Leave-in Conditioner we recommend the 56 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Leave-in Conditioner we recommend the 132 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Leave-in Conditioner we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
  'Hand cream': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Hand Cream we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Small',
        text: 'For Hand Cream we recommend the 56 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Hand Cream we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Hand Cream we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Hand Cream we recommend the 132 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Hand Cream we recommend the 275 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Small',
        text: 'For Hand Cream we recommend the 56 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Hand Cream we recommend the 132 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Hand Cream we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
  'Face mask': {
    'Small': {
      'Single-day': {
        product: 'Small',
        text: 'For Face Mask we recommend the 56 for light use over a day.'
      },
      'Three-days': {
        product: 'Small',
        text: 'For Face Mask we recommend the 56 for light use over 2-3 days.'
      },
      'Week': {
        product: 'Medium',
        text: 'For Face Mask we recommend the 132 for light use over 4-7 days.'
      }
    },
    'Mid': {
      'Single-day': {
        product: 'Small',
        text: 'For Face Mask we recommend the 56 for average use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Face Mask we recommend the 132 for average use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Face Mask we recommend the 275 for average use over 4-7 days.'
      }
    },
    'Large': {
      'Single-day': {
        product: 'Small',
        text: 'For Face Mask we recommend the 56 for heavy use over a day.'
      },
      'Three-days': {
        product: 'Medium',
        text: 'For Face Mask we recommend the 132 for heavy use over 2-3 days.'
      },
      'Week': {
        product: 'Large',
        text: 'For Face Mask we recommend the 275 for heavy use over 4-7 days.'
      }
    }
  },
}